'use client'
import type { FC } from 'react'
import { CategoryDTO } from 'ecosystem'
import { MoreCategoriesSlideOut } from 'storefront-modules/categories'
import { useSlideOut } from '#/src/custom/controllers'
import useAppConfig from '#/src/custom/hooks/useAppConfig'

export interface ISlideOutMoreCategoriesProps {
  category: CategoryDTO
}

const SlideOutMoreCategories: FC<ISlideOutMoreCategoriesProps> = ({ category }) => {
  const appConfig = useAppConfig()
  const { closeSlideOut } = useSlideOut()

  return (
    <MoreCategoriesSlideOut
      category={category}
      categoriesUrlPath={appConfig.paths.categoriesUrlPath}
      onClose={closeSlideOut}
    />
  )
}
export default SlideOutMoreCategories
